import { ElementType, Suspense, lazy } from 'react';
// components

// ----------------------------------------------------------------------

const Loadable = (Component: ElementType) => (props: any) =>
  (
    <Suspense>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
export const HomePage = Loadable(lazy(() => import('../pages/HomePage')));

// Test pages
export const Big5Page = Loadable(lazy(() => import('../pages/test/Big5Page')));
export const SalesProcessPage = Loadable(lazy(() => import('../pages/test/SalesProcessPage')));

export const AfterSalesHealthCheckPage = Loadable(lazy(() => import('../pages/test/AfterSalesHealthCheckPage')));

// Dashboard
export const DashboardPage = Loadable(lazy(() => import('../pages/DashboardPage')));
export const SuccessDashboardPage = Loadable(lazy(() => import('../pages/SuccessDashboardPage')));
